const imageUploadHandler = (blobInfo, success, failure, progress) =>
  new Promise((resolve, reject) => {
    var xhr, formData;
    xhr = new XMLHttpRequest();
    xhr.open('POST', `${process.env.NEXT_PUBLIC_BASE_URL}information/gallery/`);
    xhr.setRequestHeader('Authorization', localStorage.getItem('token'));
    xhr.upload.onprogress = function (e) {
      progress((e.loaded / e.total) * 100);
    };
    xhr.onload = function () {
      if (xhr.status === 403) {
        reject({ message: 'HTTP Error: ' + xhr.status, remove: true });
        return;
      }
      if (xhr.status < 200 || xhr.status >= 300) {
        reject('HTTP Error: ' + xhr.status);
        return;
      }
      const json = JSON.parse(xhr.responseText);
      if (!json || typeof json.data?.file != 'string') {
        reject('Invalid JSON: ' + json?.data?.file);
        return;
      }
      success(json.data?.file);
    };
    xhr.onerror = function () {
      reject(
        'Image upload failed due to a XHR Transport error. Code: ' + xhr.status
      );
    };
    formData = new FormData();
    formData.append('file', blobInfo.blob(), blobInfo.filename());
    xhr.send(formData);
  });

export const tinyeditorCofig: any = {
  // height: props?.height ? props.height : 600,
  height: 600,
  // menubar: true,
  plugins: [
    'advlist autolink lists link image charmap print preview anchor',
    'searchreplace visualblocks code fullscreen',
    'insertdatetime media table paste code help wordcount',
  ],
  toolbar:
    'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media template link anchor codesample | ltr rtl',
  content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
  selector: 'textarea#full-featured-non-premium',
  menubar: 'file edit view insert format tools table help',
  image_advtab: true,
  image_caption: true,
  file_picker_types: 'image',
  images_upload_handler: imageUploadHandler,
};